import { getRequestHeaders } from 'h3'

export const $api = $fetch.create({
    onRequest({ request, options, error }) {
        options.baseURL = `https://api.${useBenevoltDomain()}/v1`

        const platform = useSiteConfig().platform
        const userAuth = useCookie('auth_token', { readonly: true })

        if (platform) {
            options.headers.set('x-api-key', platform.api_key)
        }
        if (userAuth.value && (!platform /* || platform.slug === 'benevolt'*/)) {
            options.headers.set('Authorization', `Bearer ${userAuth.value}`)
        }

        if (import.meta.server) {
            const event = useRequestEvent()!
            const headers = getRequestHeaders(event)
            const ip =
                headers['x-real-ip'] ??
                headers['x-forwarded-for'] ??
                event?.node?.req.socket?.remoteAddress

            if (ip) {
                options.headers.set('x-real-ip', ip)
                options.headers.set('x-forwarded-for', ip)
            }
        }
    },
    async onResponseError({ response }) {
        await defaultOnResponseError(response)
        if (response.status === 422) {
            useToast().add({
                title: 'Hmm, il manque peut-être un truc...',
                description: 'Les données envoyées ne sont pas complètes ou sont incorrectes. Vérifiez les infos et réessayez ;-)',
                icon: 'i-ph-warning-duotone',
                color: 'warning'
            })
        }
    }
})